(ns minorodata.components.ai-chat.model-control
  (:require ["lucide-react" :refer [SlidersHorizontal]]
            [minorodata.ai-chat.byol :as byol]
            [minorodata.app.handlers :refer [dispatch]]
            [minorodata.app.posthog-events :as posthog-events]
            [re-frame.core :as re-frame]
            [re-posh.core :as re-posh]
            [reitit.frontend.easy :as rt.easy]
            [ui.dropdown-menu :refer [dropdown-menu dropdown-menu-label
                                      dropdown-menu-radio-group dropdown-menu-radio-item]]
            [ui.utils :refer [clsx]]))


(defn model-control []
  (let [settings @(re-posh/subscribe [:ai-settings/pull])
        chosen   @(re-frame/subscribe [:ai-chat/model])
        byol?    @(re-posh/subscribe [:unleash/is-enabled "fe.ai-byol"])
        choices  (byol/model-choices settings)
        override (byol/chosen-model settings chosen)
        active   (byol/active-choice settings chosen)
        picker?  (and (:ai-settings/allow-user-model-selection settings)
                      (seq (rest choices)))
        select   (fn [model]
                   (when (not= model (:model active))
                     (let [choice (some #(when (= model (:model %)) %) choices)]
                       (dispatch [:posthog/capture {:event (:kai/model-selected posthog-events/events)
                                                    :props {:model            model
                                                            :provider         (:provider choice)
                                                            :is_default_model (boolean (:default? choice))
                                                            :previous_model   (:model active)}}])))
                   (dispatch [:ai-chat/set-model model]))]
    (when (and byol? (:ai-settings/byol-effective settings) (seq choices))
      [dropdown-menu
       {:root-props {:on-open-change #(when %
                                        (dispatch [:posthog/capture {:event (:kai/model-selector-opened posthog-events/events)
                                                                     :props {:options_count (if picker? (count choices) 1)}}]))}
        :content (if picker?
                   [:<>
                    [dropdown-menu-label "Model for this conversation"]
                    [dropdown-menu-radio-group {:value           (:model active)
                                                :on-value-change select}
                     (for [{:keys [model default?] :as choice} choices]
                       ^{:key model}
                       [dropdown-menu-radio-item {:value model}
                        (byol/model-label choice)
                        (when default? " (default)")])]]
                   [:<>
                    [dropdown-menu-label "Model set by your workspace admin"]
                    [:div {:class "px-2 py-1 text-sm"} (byol/model-label active)]])}
       [:button {:type  "button"
                 :title (str "Model: " (byol/model-label active)
                             " — " (byol/provider-name (:provider active)))
                 :class (clsx "flex shrink-0 items-center rounded-md p-1.5 text-slate-500 hover:bg-slate-100 dark:hover:bg-slate-800"
                              {"text-kleene-secondary-v2 bg-violet-50 dark:bg-violet-950/40" (some? override)})}
        [:> SlidersHorizontal {:size 14}]]])))


(defn kai-default-notice []
  (let [settings @(re-posh/subscribe [:ai-settings/pull])
        byol?    @(re-posh/subscribe [:unleash/is-enabled "fe.ai-byol"])
        admin?   (or @(re-posh/subscribe [:users.subs/admin?])
                     @(re-posh/subscribe [:users.subs/superadmin?]))]
    (when (and byol? (byol/kai-default? settings))
      [:p {:class "mt-4 text-xs text-slate-400 dark:text-slate-500 text-center not-prose"}
       "KAI is answering using Kleene's default model."
       (when admin?
         [:<> " "
          [:a {:href  (rt.easy/href :admin {} {:tab "ai-settings"})
               :class "underline text-kleene-text-link"}
           "Go to AI settings"]])])))
